import CheckCircleOutlinedIcon from '@ant-design/icons/CheckCircleOutlined'
import CopyOutlinedIcon from '@ant-design/icons/CopyOutlined'

import { useTheme } from '@mui/material/styles'

import CopyToClipboard from '@components/CopyToClipboard'

export default function CopyIconButton({ fn, sx = {} }) {
  const theme = useTheme()

  return (
    <CopyToClipboard>
      {({ copy, copied }) => {
        const Icon = copied ? CheckCircleOutlinedIcon : CopyOutlinedIcon
        return <Icon onClick={() => fn(copy)} style={{ fontSize: 18, cursor: 'pointer', color: theme.palette.text.secondary, ...sx }} />
      }}
    </CopyToClipboard>
  )
}
